import { T } from "@/lib/i18n/T";

/**
 * Titled preview box — one large tile on the left, a stacked column of smaller
 * tiles on the right. Faithful to the old `ImagesStoreBox` (Wishlist / saved
 * looks), minus the legacy Ddimg loader: plain background tiles keep it
 * server-rendered and dependency-free.
 */
export function ImagesStoreBox({
  titleId,
  images,
  onOpen,
}: {
  titleId: string;
  images: string[];
  /** Optional: makes the whole box an accessible button (e.g. open the section). */
  onOpen?: () => void;
}) {
  const [hero, ...rest] = images;
  const interactive = onOpen
    ? {
        role: "button" as const,
        tabIndex: 0,
        onClick: onOpen,
        onKeyDown: (e: React.KeyboardEvent) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onOpen();
          }
        },
      }
    : {};
  return (
    <section className={`rubyn__dashboard__imagestorebox csx3-C00 ${onOpen ? "is-interactive" : ""}`} {...interactive}>
      <h4><T id={titleId} /></h4>
      <div className="rubyn__dashboard__imagestorebox-images csx3-R csx3-w-full">
        <span
          className="rubyn__dashboard__imagestorebox-images-l csx3-f1"
          style={hero ? { backgroundImage: `url(${hero})` } : undefined}
          aria-hidden="true"
        />
        <div className="rubyn__dashboard__imagestorebox-images-r csx3-C00">
          {rest.map((src, k) => (
            <span
              key={k}
              className="rubyn__dashboard__imagestorebox-images-r__el csx3-w-full"
              style={{ backgroundImage: `url(${src})` }}
              aria-hidden="true"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
